/**
 * Shared allowlist for distributed tracing.
 * Provides the base domains that should be traced, platform-agnostic.
 */

import { logError } from '@bts-web/utils-functions';

/**
 * Returns the base API domain for tracing whitelisting.
 */
export const getApiDomain = (): string | null => {
  const apiUrl = process.env.NEXT_PUBLIC_GQL_API_ENDPOINT_URL;

  if (!apiUrl) return null;

  try {
    const url = new URL(apiUrl);

    return url.origin;
  } catch {
    return null;
  }
};

/**
 * Returns all domains that should be whitelisted for tracing.
 * Includes API domain and VERCEL_URL for preview environments.
 */
export const getTracingDomains = (): string[] => {
  const domains: string[] = [];

  // Add API domain
  const apiDomain = getApiDomain();

  if (apiDomain) {
    domains.push(apiDomain);
  }

  let vercelUrl =
    process.env.VERCEL_URL ??
    (typeof window !== 'undefined' ? window.location.origin : undefined);

  if (vercelUrl) {
    try {
      vercelUrl = vercelUrl.startsWith('https')
        ? vercelUrl
        : `https://${vercelUrl}`;

      const url = new URL(vercelUrl);

      domains.push(url.origin);
    } catch (error) {
      logError(`Could not enable tracing for deployment URL "${vercelUrl}"}`, {
        cause: error,
      });
    }
  }

  return domains;
};
